/** Helpers for password-reset flows that must stay on the originating product app. */

export const PRODUCT_APP_IDS = {
  saas_admin: 'saas_admin',
  agentic_rcm: 'agentic_rcm',
  agentic_rcm_agency: 'agentic_rcm_agency',
  agentic_practice: 'agentic_practice',
  patient_portal: 'patient_portal',
};

export async function fetchPasswordResetContext(apiBaseUrl, token, appHint = null) {
  const qs = new URLSearchParams({ token });
  if (appHint) {
    qs.set('app', appHint);
  }
  const response = await fetch(`${apiBaseUrl}/user/password-reset/context?${qs}`);
  if (!response.ok) {
    return null;
  }
  return response.json();
}

export function shouldRedirectToUrl(targetUrl) {
  if (!targetUrl || typeof window === 'undefined') {
    return false;
  }
  try {
    return new URL(targetUrl).origin !== window.location.origin;
  } catch {
    return false;
  }
}

export async function resolvePasswordResetRouting(apiBaseUrl, token, appHint = null) {
  if (!token) {
    return { loginUrl: '/login', resetUrl: null };
  }
  const ctx = await fetchPasswordResetContext(apiBaseUrl, token, appHint);
  if (!ctx) {
    return { loginUrl: '/login', resetUrl: null };
  }
  return {
    loginUrl: ctx.login_url || '/login',
    resetUrl: ctx.reset_url || null,
    sourceApp: ctx.source_app,
  };
}
